import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/warn.svg'


const _hoisted_1 = { class: "providers-list" }
const _hoisted_2 = { class: "listing-titles" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  "data-testid": "toku-autodebit-channel"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "savings-container" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "text-black" }
const _hoisted_9 = {
  class: "sp-providers__title",
  "data-testid": "sp-providers-title"
}
const _hoisted_10 = { "data-testid": "sp-provider-popup" }
const _hoisted_11 = { "data-testid": "sp-provider-limit-popup" }
const _hoisted_12 = { "data-testid": "sp-country-notice-popup" }
const _hoisted_13 = { "data-testid": "sp-commissions-popup" }
const _hoisted_14 = { "data-testid": "sp-other-amount-popup" }
const _hoisted_15 = { "data-testid": "sp-boleto-popup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TokuAutodebitBanner = _resolveComponent("TokuAutodebitBanner")!
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_BottomBar = _resolveComponent("BottomBar")!
  const _component_HighlightPopup = _resolveComponent("HighlightPopup")!
  const _component_ProviderAmountSummary = _resolveComponent("ProviderAmountSummary")!
  const _component_ProviderCardList = _resolveComponent("ProviderCardList")!
  const _component_V1ScreenScaffold = _resolveComponent("V1ScreenScaffold")!
  const _component_Modal = _resolveComponent("Modal")!

  return (!_ctx.useRedesign)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.tokuUrl)
            ? (_openBlock(), _createBlock(_component_TokuAutodebitBanner, {
                key: 0,
                url: _ctx.tokuUrl
              }, null, 8, ["url"]))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t("PaymentsProvidersView-HowToPay")), 1),
          (_ctx.filteredProviders[0].length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProviders[0], (provider) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: provider.name
                  }, [
                    _createVNode(_component_CardItem, {
                      "logo-src": provider.logo,
                      "logo-alt": provider.displayName,
                      title: _ctx.t(provider.displayName),
                      subtitle: provider.tooltipPrefix ? _ctx.t(provider.tooltipPrefix) : '',
                      "warning-text": _ctx.formatLimitWarning(provider),
                      "right-text": _ctx.computeRightText(provider),
                      inactive: 
              provider.featureFlagStatus?.disabled === true ||
              (_ctx.country === 'PE' && _ctx.isOtherAmountSelected && !_ctx.otherAmountAllowedProviders.includes(provider.name)) ||
              !!_ctx.getLimitWarning(provider)
            ,
                      onClick: ($event: any) => (_ctx.handleSelectPaymentProvider(provider))
                    }, null, 8, ["logo-src", "logo-alt", "title", "subtitle", "warning-text", "right-text", "inactive", "onClick"])
                  ]))
                }), 128)),
                (_ctx.tokuUrl)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                      _createVNode(_component_CardItem, {
                        "logo-src": _ctx.addCardIcon,
                        "logo-alt": _ctx.t('TokuAutodebit-Channel-Title'),
                        title: _ctx.t('TokuAutodebit-Channel-Title'),
                        "right-text": _ctx.t('no-fee'),
                        onClick: _ctx.openTokuUrl
                      }, null, 8, ["logo-src", "logo-alt", "title", "right-text", "onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.filteredProviders[1].length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProviders[1], (provider) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: provider.name
                  }, [
                    _createVNode(_component_CardItem, {
                      "logo-src": provider.logo,
                      "logo-alt": provider.displayName,
                      title: _ctx.t(provider.displayName),
                      subtitle: provider.tooltipPrefix ? _ctx.t(provider.tooltipPrefix) : '',
                      "warning-text": _ctx.formatLimitWarning(provider),
                      "right-text": _ctx.computeRightText(provider),
                      inactive: 
              provider.featureFlagStatus?.disabled === true ||
              (_ctx.country === 'PE' && _ctx.isOtherAmountSelected && !_ctx.otherAmountAllowedProviders.includes(provider.name)) ||
              !!_ctx.getLimitWarning(provider)
            ,
                      onClick: ($event: any) => (_ctx.handleSelectPaymentProvider(provider))
                    }, null, 8, ["logo-src", "logo-alt", "title", "subtitle", "warning-text", "right-text", "inactive", "onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_BottomBar, {
          text: _ctx.t('PaymentsProvidersView-PaymentAmount'),
          amount: _ctx.amount,
          "term-label": _ctx.term,
          onChangePaymentAmount: _ctx.handleAmountChange
        }, null, 8, ["text", "amount", "term-label", "onChangePaymentAmount"]),
        _createVNode(_component_HighlightPopup, {
          "is-visible": _ctx.onHighlighted,
          onClosePopup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClosePopup('highLight'))),
          onDismissPopup: _ctx.onDismissPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("h1", null, _toDisplayString(_ctx.t("Popup-Pay-Without-Commissions")), 1),
            _createElementVNode("h2", null, _toDisplayString(_ctx.t("Popup-Save-Money-Using-These-Options")), 1),
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlightedProviders, (provider) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: _ctx.t(provider.name),
                  class: "savings"
                }, [
                  _createElementVNode("img", {
                    src: provider.logo,
                    alt: provider.displayName
                  }, null, 8, _hoisted_7)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["is-visible", "onDismissPopup"]),
        (_ctx.pixProvider)
          ? (_openBlock(), _createBlock(_component_HighlightPopup, {
              key: 0,
              id: "boletoPopup",
              "is-visible": _ctx.showBoletoPopup,
              "bottom-link-text": _ctx.t('try-with-pix'),
              "button-text": _ctx.boletoPopupButtonText,
              onBottomLinkClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tryPix())),
              onClosePopup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClosePopup('boletoPopup'))),
              onDismissPopup: _ctx.onDismissPopup
            }, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Warning"
                }, null, -1)),
                _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.boletoPopupTitle), 1),
                _createElementVNode("h2", null, _toDisplayString(_ctx.boletoPopupDescription), 1)
              ]),
              _: 1
            }, 8, ["is-visible", "bottom-link-text", "button-text", "onDismissPopup"]))
          : _createCommentVNode("", true),
        _createVNode(_component_HighlightPopup, {
          "is-visible": _ctx.detailsPopupObject !== undefined,
          "button-text": 
      _ctx.detailsPopupObject?.disabled == true ? (_ctx.showExtensionCta ? _ctx.t('use-another-method') : _ctx.t('close')) : _ctx.t('continue')
    ,
          "bottom-link-text": 
      _ctx.showExtensionCta ? _ctx.t('ext-entry-option-subtitle') : _ctx.detailsPopupObject?.disabled == true ? undefined : _ctx.t('cancel')
    ,
          "bottom-link-highlight": _ctx.showExtensionCta,
          "bottom-link-test-id": _ctx.showExtensionCta ? 'request-extension-button' : '',
          "add-close-icon": _ctx.showExtensionCta,
          onClosePopup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClosePopup('details'))),
          onDismissPopup: _ctx.onDismissPopup,
          onDismissPopupCloseBtn: _ctx.onDismissPopup,
          onBottomLinkClick: _ctx.onDetailsBottomLink
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  height: "67",
                  alt: "Info"
                })
              ], -1)),
              _createElementVNode("h1", null, _toDisplayString(_ctx.detailsPopupObject?.title), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.detailsPopupObject?.banner), 1)
            ])
          ]),
          _: 1
        }, 8, ["is-visible", "button-text", "bottom-link-text", "bottom-link-highlight", "bottom-link-test-id", "add-close-icon", "onDismissPopup", "onDismissPopupCloseBtn", "onBottomLinkClick"]),
        _createVNode(_component_HighlightPopup, {
          "is-visible": 
      !!_ctx.providers.globalWarning.value?.title && !!_ctx.providers.globalWarning.value?.banner && !_ctx.globalWarningDismissed
    ,
          "button-text": _ctx.t('close'),
          "bottom-link-text": _ctx.globalWarningExtensionCta ? _ctx.t('ext-entry-option-subtitle') : undefined,
          "bottom-link-highlight": _ctx.globalWarningExtensionCta,
          "bottom-link-test-id": _ctx.globalWarningExtensionCta ? 'request-extension-button-country' : '',
          onClosePopup: _ctx.dismissGlobalWarning,
          onDismissPopup: _ctx.dismissGlobalWarning,
          onBottomLinkClick: _ctx.onGlobalWarningExtension
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  height: "67",
                  alt: "Info"
                })
              ], -1)),
              _createElementVNode("h1", null, _toDisplayString(_ctx.providers.globalWarning.value?.title), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.providers.globalWarning.value?.banner), 1)
            ])
          ]),
          _: 1
        }, 8, ["is-visible", "button-text", "bottom-link-text", "bottom-link-highlight", "bottom-link-test-id", "onClosePopup", "onDismissPopup", "onBottomLinkClick"]),
        _createVNode(_component_HighlightPopup, {
          "is-visible": _ctx.showOtherAmountPopup,
          "button-text": _ctx.t('close'),
          onClosePopup: _ctx.onDismissPopup,
          onDismissPopup: _ctx.onDismissPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  height: "67",
                  alt: "Info"
                })
              ], -1)),
              _createElementVNode("h1", null, _toDisplayString(_ctx.t("attention")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.t("other-amount-qr-content")), 1)
            ])
          ]),
          _: 1
        }, 8, ["is-visible", "button-text", "onClosePopup", "onDismissPopup"])
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_V1ScreenScaffold, {
          "data-testid": "sp-providers",
          "next-disabled": !_ctx.canContinueRedesign,
          onNext: _ctx.onRedesignContinue
        }, {
          subtitle: _withCtx(() => [
            (_ctx.superPacmanInstallment)
              ? (_openBlock(), _createBlock(_component_ProviderAmountSummary, {
                  key: 0,
                  label: _ctx.t('PaymentsProvidersView-PaymentAmount'),
                  amount: _ctx.redesignAmountDisplay,
                  "next-payment": _ctx.redesignNextPayment,
                  "test-id": "sp-providers-amount",
                  "next-payment-test-id": "sp-providers-next-payment"
                }, null, 8, ["label", "amount", "next-payment"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_ctx.tokuUrl)
              ? (_openBlock(), _createBlock(_component_TokuAutodebitBanner, {
                  key: 0,
                  url: _ctx.tokuUrl
                }, null, 8, ["url"]))
              : _createCommentVNode("", true),
            _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.t("PaymentsProvidersView-SelectHowToPay")), 1),
            _createVNode(_component_ProviderCardList, {
              items: _ctx.redesignCardItems,
              "selected-key": _ctx.selectedProviderKey,
              onSelect: _ctx.handleRedesignSelect
            }, null, 8, ["items", "selected-key", "onSelect"])
          ]),
          _: 1
        }, 8, ["next-disabled", "onNext"]),
        _createVNode(_component_Modal, {
          "model-value": _ctx.detailsPopupObject !== undefined,
          placement: "bottom",
          title: _ctx.detailsPopupObject?.title,
          "primary-text": 
        _ctx.detailsPopupObject?.disabled == true
          ? _ctx.showExtensionCta
            ? _ctx.t('use-another-method')
            : _ctx.t('close')
          : _ctx.t('continue')
      ,
          "secondary-text": 
        _ctx.showExtensionCta
          ? _ctx.t('ext-entry-option-subtitle')
          : _ctx.detailsPopupObject?.disabled == true
            ? undefined
            : _ctx.t('cancel')
      ,
          onPrimary: _ctx.onRedesignDetailsPrimary,
          onSecondary: _ctx.onDetailsBottomLink,
          "onUpdate:modelValue": _ctx.onDismissPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.detailsPopupObject?.banner), 1)
          ]),
          _: 1
        }, 8, ["model-value", "title", "primary-text", "secondary-text", "onPrimary", "onSecondary", "onUpdate:modelValue"]),
        _createVNode(_component_Modal, {
          "model-value": _ctx.limitPopupProvider !== undefined,
          placement: "bottom",
          title: _ctx.limitPopupTitle,
          "primary-text": _ctx.t('close'),
          onPrimary: _ctx.onRedesignLimitClose,
          "onUpdate:modelValue": _ctx.onRedesignLimitClose
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.limitPopupBody), 1)
          ]),
          _: 1
        }, 8, ["model-value", "title", "primary-text", "onPrimary", "onUpdate:modelValue"]),
        _createVNode(_component_Modal, {
          "model-value": 
        !!_ctx.providers.globalWarning.value?.title && !!_ctx.providers.globalWarning.value?.banner && !_ctx.globalWarningDismissed
      ,
          placement: "bottom",
          title: _ctx.providers.globalWarning.value?.title,
          "primary-text": _ctx.t('close'),
          "secondary-text": _ctx.globalWarningExtensionCta ? _ctx.t('ext-entry-option-subtitle') : undefined,
          onPrimary: _ctx.dismissGlobalWarning,
          onSecondary: _ctx.onGlobalWarningExtension,
          "onUpdate:modelValue": _ctx.dismissGlobalWarning
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.providers.globalWarning.value?.banner), 1)
          ]),
          _: 1
        }, 8, ["model-value", "title", "primary-text", "secondary-text", "onPrimary", "onSecondary", "onUpdate:modelValue"]),
        _createVNode(_component_Modal, {
          "model-value": _ctx.onHighlighted,
          placement: "bottom",
          title: _ctx.t('Popup-Pay-Without-Commissions'),
          "primary-text": _ctx.t('close'),
          onPrimary: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClosePopup('highLight'))),
          "onUpdate:modelValue": _ctx.onDismissPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t('Popup-Save-Money-Using-These-Options')), 1)
          ]),
          _: 1
        }, 8, ["model-value", "title", "primary-text", "onUpdate:modelValue"]),
        _createVNode(_component_Modal, {
          "model-value": _ctx.showOtherAmountPopup,
          placement: "bottom",
          title: _ctx.t('attention'),
          "primary-text": _ctx.t('close'),
          onPrimary: _ctx.onDismissPopup,
          "onUpdate:modelValue": _ctx.onDismissPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t('other-amount-qr-content')), 1)
          ]),
          _: 1
        }, 8, ["model-value", "title", "primary-text", "onPrimary", "onUpdate:modelValue"]),
        (_ctx.pixProvider)
          ? (_openBlock(), _createBlock(_component_Modal, {
              key: 0,
              "model-value": _ctx.showBoletoPopup,
              placement: "bottom",
              title: _ctx.boletoPopupTitle,
              "primary-text": _ctx.boletoPopupButtonText,
              "secondary-text": _ctx.t('try-with-pix'),
              onPrimary: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClosePopup('boletoPopup'))),
              onSecondary: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tryPix())),
              "onUpdate:modelValue": _ctx.onDismissPopup
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.boletoPopupDescription), 1)
              ]),
              _: 1
            }, 8, ["model-value", "title", "primary-text", "secondary-text", "onUpdate:modelValue"]))
          : _createCommentVNode("", true)
      ], 64))
}